import React from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';
import SEO from '../components/SEO';
const POSTS = [
  { bg:'bh1', ico:'🤖', cat:'AI & Automation',       title:'How AI is Transforming Business Workflows Beyond Chatbots',       desc:'Real AI value comes from automating document processing, extracting structured data, and enabling intelligent search at scale.',             time:'8 min read', url:'/blog/ai-workflows'},
  { bg:'bh2', ico:'⚡', cat:'Framework Comparison',  title:'Django vs FastAPI: Choosing the Right Backend Framework',          desc:'Both Django and FastAPI are powerful, but serve different needs. A practical comparison of when to use each — and when to combine both.',    time:'6 min read', url:'/blog/django-vs-fastapi' },
  { bg:'bh3', ico:'🔗', cat:'API Design',             title:'Building Reliable APIs: What Most Systems Get Wrong',              desc:'Inconsistent formats, poor error handling, no versioning. Here\'s how to build APIs that last and scale under real load.',                  time:'7 min read', url:'/blog/building-reliable-apis' },
  { bg:'bh4', ico:'🔄', cat:'Business Automation',   title:'From Manual Work to Automation: A Real Business Shift',            desc:'Integrating automation layers without replacing systems — and what that actually looks like in practice for operations teams.',             time:'5 min read', url:'/blog/business-automation' },
  { bg:'bh5', ico:'☁️', cat:'Cloud Engineering',     title:'Structuring AWS Deployments for Django Applications',              desc:'A practical guide to deploying production Django on AWS — EC2, RDS, S3, HTTPS, and monitoring — done right the first time.',              time:'10 min read', url:'/blog/structuring-aws-deployments' },
  { bg:'bh6', ico:'🌊', cat:'Data Engineering',      title:'Apache Airflow DAGs, Tasks, and Operators Explained Simply',      desc:'Airflow\'s core concepts demystified — DAG anatomy, task dependencies, operator types, and scheduling — without the rabbit hole.',         time:'9 min read', url:'/blog/apache-airflow-explained' },
];

export default function Blog() {
  useReveal();

  const handleSubscribe = e => {
    e.preventDefault();
    alert('Thanks! You\'ll hear from us soon.');
  };

  return (
    <div className="page">
      <SEO
        title="Blog — Backend Engineering, AI & Automation Insights | Arhatinfo"
        description="Technical articles on backend engineering, AI automation, Django, FastAPI, Python, and cloud infrastructure. Written by Rohit Jain, founder of Arhatinfo."
        keywords="backend engineering blog, AI automation blog, Django tutorials, FastAPI guide, Python development, software architecture, cloud infrastructure, Rohit Jain blog, arhatinfo blog"
        canonical="https://arhatinfo.com/blog"
        og={{
          title:       "Arhatinfo Blog — Backend Engineering & AI Automation",
          description: "Technical insights on Django, FastAPI, AI workflows, API design, and business automation. Written by Rohit Jain.",
          url:         "https://arhatinfo.com/blog",
          image:       "https://arhatinfo.com/og-blog.png",
        }}
      />
      <div className="ph rv">
        <div className="s-label">Blog</div>
        <h1>Engineering Insights<br />From Production</h1>
        <p className="lead">Articles on backend architecture, AI integration, cloud systems, and automation — written from hands-on experience, not textbooks.</p>
      </div>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">

          {/* Featured */}
          <div className="blog-feat rv">
            <div className="bf-visual">🏗️</div>
            <div className="bf-body">
              <div className="bf-cat">Backend Architecture</div>
              <h2>Why Backend Architecture Matters More Than Features</h2>
              <p>Most teams focus heavily on building features quickly. But without a solid backend architecture, systems become difficult to maintain, scale, and extend. We've seen systems fail not because of lack of features, but because of poor structure — here's what that looks like and how to avoid it.</p>
              <a href="/blog/backend-architecture" className="btn-p" style={{ fontSize: '.85rem', padding: '.7rem 1.4rem' }}>Read Article →</a>
            </div>
          </div>

          {/* Grid */}
          <div className="blog-grid">
            {POSTS.map((p, i) => (
              <div key={i} className={`blog-card rv d${(i % 3) + 1}`}>
                <div className={`blog-img ${p.bg}`}>{p.ico}</div>
                <div className="blog-body">
                  <div className="blog-cat">{p.cat}</div>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                </div>
                <div className="blog-footer">
                  <span className="blog-meta">{p.time}</span>
                  <a href={p.url} className="blog-more">Read →</a>
                </div>
              </div>
            ))}
          </div>

          {/* Newsletter */}
          <div className="newsletter rv">
            <h3>Get new articles in your inbox</h3>
            <p>Practical engineering content — no fluff, no spam. Unsubscribe anytime.</p>
            <form className="email-row" onSubmit={handleSubscribe}>
              <input type="email" className="email-inp" placeholder="your@email.com" required />
              <button type="submit" className="btn-p" style={{ whiteSpace: 'nowrap', fontSize: '.85rem', padding: '.75rem 1.2rem' }}>
                Subscribe
              </button>
            </form>
          </div>

        </div>
      </section>
    </div>
  );
}
